import React from 'react';
import { Box, Image, Spinner } from '@chakra-ui/react';
import foodfluenceIcon from '../assets/foodfluence-app-icon.png';

interface FoodfluenceLoaderProps {
  /** Diameter of the whole badge, ring included. */
  size?: string;
  /** Announced to screen readers in place of the generic "Loading...". */
  label?: string;
}

/**
 * Brand loading indicator: the Foodfluence mark held still inside a rotating ring. Used wherever a
 * wait is long enough that a bare Chakra spinner reads as "something generic is happening".
 */
const FoodfluenceLoader: React.FC<FoodfluenceLoaderProps> = ({ size = '28px', label = 'Loading' }) => (
  <Box position="relative" w={size} h={size} flexShrink={0} role="status" aria-label={label}>
    <Spinner
      label=""
      position="absolute"
      inset={0}
      w="100%"
      h="100%"
      thickness="2px"
      speed="0.7s"
      color="gray.700"
      emptyColor="blackAlpha.200"
    />
    <Image
      src={foodfluenceIcon}
      alt=""
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      w="58%"
      h="58%"
      objectFit="contain"
    />
  </Box>
);

export default FoodfluenceLoader;
